import EventHandlers from "@/services/handlers";

interface IEventHandler {
    modalChanged?: (hasModal: boolean) => void;
}

class ModalService {
    private readonly handlers = new EventHandlers<IEventHandler>();

    private hasModalValue = false;

    public get hasModal() {
        return this.hasModalValue;
    }

    public set hasModal(value: boolean) {
        if (value === this.hasModalValue) {
            return;
        }

        this.hasModalValue = value;
        this.handlers.publish((x) => x.modalChanged?.(value));
    }

    public subscribe(handler: IEventHandler) {
        return this.handlers.register(handler);
    }
}

const modal = new ModalService();
export default modal;
